export const shopPods = () => '/shop-pods';
export const checkout = () => '/checkout';
export const autoShip = () => '/auto-ship';



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/paths.js